module.exports = __webpack_public_path__ + "img/stale.e91e3df4.svg";